import React, { useEffect, useState } from "react";
import {
  Getagencypatientdetails,
  Patientrequestupdates,
} from "../../api/helper";
import { useForm } from "react-hook-form";
import { ShowToast } from "../../helpers/ToastService";
import Inputbox from "../Components/Inputbox";
import { Button, Card, CardContent, Label } from "./ReuseableComponent/alert";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const BasicInfoForm = ({ data, onComplete }) => {
  const [patientData, setPatientData] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (formData) => {
    formData.id = data?.response?.patientRequestId;
    try {
      const response = await Patientrequestupdates(formData);
      // UpdateTabstatus("Basic Information");
      ShowToast(response?.data?.message);
      onComplete(true);
      GetInfo();
      // handleSave();
    } catch (error) {
      console.log(error);
    }
  };

  const GetInfo = async () => {
    try {
      const response = await Getagencypatientdetails(
        data?.response?.patientRequestId
      );
      const resData = response?.data?.data;
      setPatientData(resData);
      const addressData = resData?.address || {};

      setValue("address.street", addressData?.street || "");
      setValue("address.city", addressData?.city || "");
      setValue("address.state", addressData?.state || "");
      setValue("address.country", addressData?.country || "");
      setValue("address.zipCode", addressData?.zipCode || "");
      setValue("firstName", resData?.firstName || "");
      setValue("lastName", resData?.lastName || "");
      setValue("phone", resData?.phone || "");
      setValue("sex", resData?.gender || "");
    } catch (error) {
      console.error("Failed to fetch patient details", error);
    }
  };

  useEffect(() => {
    GetInfo();
  }, []);

  const handleSave = () => {
    onComplete?.(true);
  };

  const handleDownloadPDF = () => {
    if (!patientData) {
      ShowToast("Patient data not loaded yet.");
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text("Patient Basic Information", 14, 22);

    const rows = [
      ["First Name", patientData.firstName || ""],
      ["Last Name", patientData.lastName || ""],
      ["Phone", patientData.phone || ""],
      ["Gender", patientData.gender || ""],
      ["Street", patientData?.address?.street || ""],
      ["City", patientData?.address?.city || ""],
      ["State", patientData?.address?.state || ""],
      ["Country", patientData?.address?.country || ""],
      ["Zip Code", patientData?.address?.zipCode || ""],
      // Add more fields if needed
    ];

    autoTable(doc, {
      startY: 30,
      head: [["Field", "Value"]],
      body: rows,
    });

    doc.save(`Patient_Info_${patientData.firstName || "Details"}.pdf`);
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="BasicInfo_form_container"
        >
          <div className="form-grid">
            <div className="field-group">
              <Label htmlFor="firstName">First Name *</Label>
              <input
                id="firstName"
                {...register("firstName", {
                  required: "First name is required",
                })}
                className="verifyidentity-input"
              />
              {errors.firstName && (
                <p className="BasicInfo_error_text">
                  {errors.firstName.message}
                </p>
              )}
            </div>

            {/* Last Name */}
            <div className="field-group">
              <Label htmlFor="lastName">Last Name *</Label>
              <input
                id="lastName"
                {...register("lastName", {
                  required: "Last name is required",
                })}
                className="verifyidentity-input"
              />
              {errors.lastName && (
                <p className="BasicInfo_error_text">
                  {errors.lastName.message}
                </p>
              )}
            </div>
          </div>

          {/* Address Street */}
          <div className="field-group">
            <Label htmlFor="address.street">Street Address *</Label>
            <input
              id="address.street"
              {...register("address.street", {
                required: "Street address is required",
              })}
              className="verifyidentity-input"
            />
            {errors.address?.street && (
              <p className="BasicInfo_error_text">
                {errors.address.street.message}
              </p>
            )}
          </div>

          {/* City, State, Country */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="field-group">
              <Label htmlFor="address.city">City *</Label>
              <input
                id="address.city"
                {...register("address.city", {
                  required: "City is required",
                })}
                className="verifyidentity-input"
              />
              {errors.address?.city && (
                <p className="BasicInfo_error_text">
                  {errors.address.city.message}
                </p>
              )}
            </div>

            <div className="field-group">
              <Label htmlFor="address.state">State *</Label>
              <input
                id="address.state"
                {...register("address.state", {
                  required: "State is required",
                })}
                className="verifyidentity-input"
              />
              {errors.address?.state && (
                <p className="BasicInfo_error_text">
                  {errors.address.state.message}
                </p>
              )}
            </div>

            <div className="field-group">
              <Label htmlFor="address.country">Country *</Label>
              <input
                id="address.country"
                {...register("address.country", {
                  required: "Country is required",
                })}
                className="verifyidentity-input"
              />
              {errors.address?.country && (
                <p className="BasicInfo_error_text">
                  {errors.address.country.message}
                </p>
              )}
            </div>
          </div>

          {/* Zip Code */}
          <div className="field-group">
            <Label htmlFor="address.zipCode">Zip Code *</Label>
            <input
              id="address.zipCode"
              {...register("address.zipCode", {
                required: "Zip code is required",
              })}
              className="verifyidentity-input"
            />
            {errors.address?.zipCode && (
              <p className="BasicInfo_error_text">
                {errors.address.zipCode.message}
              </p>
            )}
          </div>

          {/* Phone & Sex */}
          <div className="form-grid">
            <div className="field-group">
              <Label htmlFor="phone">Phone Number *</Label>
              <input
                id="phone"
                type="tel"
                {...register("phone", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^[0-9]{10,15}$/,
                    message: "Enter valid phone number",
                  },
                })}
                className="verifyidentity-input"
              />
              {errors.phone && (
                <p className="BasicInfo_error_text">{errors.phone.message}</p>
              )}
            </div>

            <div className="field-group">
              <Label htmlFor="sex">Sex *</Label>
              <input
                id="sex"
                className="verifyidentity-input"
                {...register("sex", { required: "Sex is required" })}
              />
              {errors.sex && (
                <p className="BasicInfo_error_text">{errors.sex.message}</p>
              )}
            </div>
          </div>

          <Button
            type="submit"
            className="w-full bg-[#BC9C22] hover:bg-[#9e7f1f]"
          >
            Save Basic Information
          </Button>
        </form>

        {/* Download PDF Button */}
        <Button
          style={{ marginTop: 10 }}
          className="w-full bg-[#BC9C22] hover:bg-[#9e7f1f]"
          onClick={handleDownloadPDF}
        >
          Download PDF
        </Button>
      </CardContent>
    </Card>
  );
};

export default BasicInfoForm;
